<template>
	<div class="submit-wrapper">
		<div class="logo">
			<img src="../assets/img/logo.png" alt="">
		</div>
		<div class="form-container">
			<form novalidate class="form-content">
				<div class="des">
					<p>Submitted Successfully！</p>
				</div>
				<div>
					<button class="submit-button" type="button" @click="returnHandler">Return</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Submit',

		methods: {
			returnHandler() {
				this.$router.push({
					name: 'home'
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.mobile {
		.submit-wrapper {
			.form-container {
				padding: 5%;

				.form-content {
					padding: 20px;
				}
			}
		}
	}
	.submit-wrapper {
		background-color: #000000;
		min-height: 100%;
		overflow: hidden;

		.logo {
			width: 220px;
			height: 66px;
			margin: 5% auto 0;
			img {
				display: block;
				height: 100%;
			}
		}

		.form-container {
			display: flex;
			justify-content: center;
			padding: 5% 10%;

			.form-content {
				padding: 50px 75px;
				background-color: #fff;
			    border-radius: 10px;
			    max-width: 882px;
			    position: relative;
			    width: 100%;
			}

			.des {
				font-size: 16px;
				color: rgba(0, 0, 0, 0.54);
				text-align: center;
			}

			.submit-button {
				background-color: #4A90E2;
			    border-radius: 3px;
			    display: block;
			    color: #fff;
			    margin: 40px auto 20px;
			    outline: none;
			    padding: 13px 30px;
			    transition: background-color 0.4s;
			    font-family: "Lato", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
		        font-size: 14px;
		        font-weight: 700;
		        line-height: normal;
				border: 0;
				cursor: pointer;
			}

			.submit-button:hover {
				border: 0;
				box-shadow: none;
				background-color: #63a3f7;
			}

			.submit-button:active {
				border: 0;
				box-shadow: none;
				background-color: #4b7ec1;
			}
		}
	}
</style>